import { $vars } from '../../config/vars';
import { yLoadAsyncScript, yDefer } from './util';

export namespace $google {
    let google_promise: Promise<void> | undefined;

    let token_client: any;

    function init() {
        if(!google_promise) {
            const config = $vars.google_api;

            google_promise = Promise.all([yLoadAsyncScript('https://apis.google.com/js/api.js'), yLoadAsyncScript('https://accounts.google.com/gsi/client')]).then(() => {
                const deferred = yDefer<void>();

                token_client = (google as any).accounts.oauth2.initTokenClient({
                    client_id: config.client_id,
                    scope: 'https://www.googleapis.com/auth/contacts.readonly',
                    callback: '',  // defined at request time
                });

                gapi.load('client', () => {
                    gapi.client.init({
                        apiKey: config.key,
                        discoveryDocs: ['https://people.googleapis.com/$discovery/rest']
                    }).then(() => {
                        deferred.resolve();
                    }, error => {
                        deferred.reject(error);
                    });
                });

                return deferred.promise;
            });
        }

        return google_promise;
    }

    export function prepare() {
        init();
    }

    let auth_promise: Promise<void> | undefined;

    export function auth() {
        if(!auth_promise) {
            auth_promise = init().then(() => {
                const deferred = yDefer<void>();

                token_client.callback = (r: any) => {
                    if(r.error !== undefined)
                        deferred.reject(r);

                    // GIS has automatically updated gapi.client with the newly issued access token.
                    deferred.resolve();
                }
                token_client.requestAccessToken();

                return deferred.promise;
            });
        }

        return auth_promise;
    }

    export function signOut() {
        init().then(() => {
            const auth = gapi.auth2.getAuthInstance();
            if(auth.isSignedIn.get()) {
                auth.signOut();
            }
        });
    }

    export interface Contact {
        name: string;
        first_name: string;
        email: string;
    }

    export function getContacts() {
        return auth().then(() => {
            const parameters = { resourceName: 'people/me', pageSize: 1000, personFields: 'emailAddresses,names' }

            return gapi.client.people.people.connections.list(parameters).then<Contact[]>(people => {
                const contacts: Contact[] = [];
                if(people.result.connections) {
                    for(const p of people.result.connections) {
                        if(!p.names || !p.names.length || !p.emailAddresses || !p.emailAddresses.length) continue;
                        contacts.push({ name: p.names[0].displayName, first_name: p.names[0].givenName, email: p.emailAddresses[0].value });
                    }
                }

                return contacts;
            });
        });
    }
}
